import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { style } from '../../utils/style.js';
import { ArrowButton } from './ArrowButton.js';
/** @deprecated */
export function renderArrows({ dec, inc, canDec, canInc, btnClass, className = '', }) {
    const isVisible = canDec || canInc;
    if (!isVisible) {
        return null;
    }
    return (_jsxs("div", { children: [canDec ? (_jsx(ArrowButton, { className: style('absolute z-40', btnClass[0], className), onClick: dec, ariaLabel: "\u041F\u0440\u043E\u043B\u0438\u0441\u0442\u0430\u0442\u044C \u0432\u043B\u0435\u0432\u043E", "data-block-control": "scroll-left", disabled: !canDec })) : null, canInc ? (_jsx(ArrowButton, { className: style('absolute z-40 rotate-180', btnClass[1], className), onClick: inc, ariaLabel: "\u041F\u0440\u043E\u043B\u0438\u0441\u0442\u0430\u0442\u044C \u0432\u043F\u0440\u0430\u0432\u043E", "data-block-control": "scroll-right", disabled: !canInc })) : null] }));
}
//# sourceMappingURL=renderArrows.js.map